<template>
  <b-card>
    <b-row>
      <b-col
        lg="4"
        v-for="({ key, name, type, options }) in fields"
        :key="key"
      >
        <b-form-group
          v-if="['STRING', 'ENUM', 'LOCATION'].includes(type)"
          :label-for="`input-${key}`"
          label-class="pb-2"
          :label="name"
        >
          <b-form-select
            v-if="type === 'ENUM' && options"
            :id="`input-${key}`"
            type="text"
            :options="options"
            :value="inputValues[key]"
            @input="input($event, key)"
          >
              <template v-slot:first><option :value="null">-- Please select an option --</option></template>
          </b-form-select>
          <location-search
            v-else-if="type === 'LOCATION'"
            :value="inputValues[key]"
            @input="input($event, key)"
          />
          <b-form-input
            v-else :id="`input-${key}`"
            placeholder="Type to search"
            type="text"
            :value="inputValues[key]"
            @input="input($event, key)"
          />
        </b-form-group>
        <job-title-selector
          v-if="type === 'JOB_TITLES'"
          :options="options"
          :value="inputValues[key]"
          :name="name"
          :settings="{ noHeader: true }"
          @input="input($event, key)"
        />
        <job-skills-selector
          v-if="type === 'JOB_SKILLS'"
          :options="options"
          :name="name"
          :settings="{ noHeader: true }"
          :value="inputValues[key]"
          @input="input($event, key)"
        />
        <languages-selector
          v-if="type === 'LANGUAGES'"
          :value="inputValues[key]"
          @input="input($event, key)"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import JobTitleSelector from '@/components/profile/JobTitleSelector';
import JobSkillsSelector from '@/components/profile/JobSkillsSelector';
import LanguagesSelector from '@/components/profile/LanguagesSelector';
import LocationSearch from '@/components/misc/LocationSearch';

export default {
  name: 'FilterBlock',
  components: {
    JobTitleSelector,
    JobSkillsSelector,
    LanguagesSelector,
    LocationSearch,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      inputValues: this.value,
    };
  },
  watch: {
    value() {
      this.inputValues = this.value;
    }
  },
  methods: {
    input(value, key) {
      this.inputValues[key] = value;
      this.$emit('input', this.inputValues);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/misc/FilterBlock.vue